<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"600px"'
    :cpntOnFecharDialog='demComandaRapidaFechar'>
    <template slot='titulo'>
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
      Comanda Rápido
    </template>
    
    <template slot='conteudo'>
      <div class="dem-edi-com-rap">
        <div class="campos">
          <App-Autocompletar :data-time="time" class="app-cpnt-field dem-edi-com-rap--item"
          :cpntStatus='campos.item.status'
          :cpntId='campos.item.id'
          :cpntTabIndex='campos.item.tabIndex'
          :cpntNome='campos.item.nome'
          :cpntValue='campos.item.value'
          :cpntMensagem='campos.item.mensagem'
          :cpntMensagemTipo='campos.item.mensagemTipo'
          :cpntDisabled='campos.item.disabled'
          :cpntMostrar='campos.item.mostrar'
          :cpntExplica='campos.item.explica'
          :cpntPlaceholder='campos.item.placeholder'
          :cpntValueRef='campos.item.valueRef'
          :cpntRouter='campos.item.router'
          :cpntMethod='campos.item.method'
          :cpntField='campos.item.field'
          :cpntFieldVirtual='campos.item.fieldVirtual'
          :cpntWhere='campos.item.where'
          :cpntAddButForm='campos.item.addButForm'
          :cpntKeyMostra='campos.item.keyMostra'
          :cpntTipoOrder='campos.item.tipoOrder'
          :cpntOrder='campos.item.order'
          :cpntOptions='campos.item.options'
          :cpntKeyValue='campos.item.keyValue'
          :cpntSearchMinimo='campos.item.searchMinimo'
          :cpntMask='campos.item.mask'
          :cpntNewOption='campos.item.newOption'

          :cpntOnChange='campos.item.onChange'
          :cpntOnBlur='campos.item.onBlur'
          :cpntOnRealizaBusca='campos.item.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.item.onKeyPressEnter'
          ref="item"
          ></App-Autocompletar>

          <App-Input :data-time="time" class="app-cpnt-field dem-edi-com-rap--qtde"
          :cpntStatus='campos.qtde.status'
          :cpntId='campos.qtde.id'
          :cpntTabIndex='campos.qtde.tabIndex'
          :cpntNome='campos.qtde.nome'
          :cpntValue='campos.qtde.value'
          :cpntMensagem='campos.qtde.mensagem'
          :cpntMensagemTipo='campos.qtde.mensagemTipo'
          :cpntDisabled='campos.qtde.disabled'
          :cpntMostrar='campos.qtde.mostrar'
          :cpntExplica='campos.qtde.explica'
          :cpntPlaceholder='campos.qtde.placeholder'
          :cpntValueRef='campos.qtde.valueRef'
          :cpntRouter='campos.qtde.router'
          :cpntField='campos.qtde.field'
          :cpntWhere='campos.qtde.where'
          :cpntAddButForm='campos.qtde.addButForm'
          :cpntKeyMostra='campos.qtde.keyMostra'
          :cpntTipoOrder='campos.qtde.tipoOrder'
          :cpntOrder='campos.qtde.order'
          :cpntOptions='campos.qtde.options'
          :cpntKeyValue='campos.qtde.keyValue'
          :cpntSearchMinimo='campos.qtde.searchMinimo'
          :cpntMask='campos.qtde.mask'

          :cpntOnChange='campos.qtde.onChange'
          :cpntOnBlur='campos.qtde.onBlur'
          :cpntOnRealizaBusca='campos.qtde.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.qtde.onKeyPressEnter'
          ref="qtde"
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field dem-edi-com-rap--valor_uni"
          :cpntStatus='campos.valor_uni.status'
          :cpntId='campos.valor_uni.id'
          :cpntTabIndex='campos.valor_uni.tabIndex'
          :cpntNome='campos.valor_uni.nome'
          :cpntValue='campos.valor_uni.value'
          :cpntMensagem='campos.valor_uni.mensagem'
          :cpntMensagemTipo='campos.valor_uni.mensagemTipo'
          :cpntDisabled='campos.valor_uni.disabled === true || cpntPDocNFEmitida === true'
          :cpntMostrar='campos.valor_uni.mostrar'
          :cpntExplica='campos.valor_uni.explica'
          :cpntPlaceholder='campos.valor_uni.placeholder'
          :cpntValueRef='campos.valor_uni.valueRef'
          :cpntRouter='campos.valor_uni.router'
          :cpntField='campos.valor_uni.field'
          :cpntWhere='campos.valor_uni.where'
          :cpntAddButForm='campos.valor_uni.addButForm'
          :cpntKeyMostra='campos.valor_uni.keyMostra'
          :cpntTipoOrder='campos.valor_uni.tipoOrder'
          :cpntOrder='campos.valor_uni.order'
          :cpntOptions='campos.valor_uni.options'
          :cpntKeyValue='campos.valor_uni.keyValue'
          :cpntSearchMinimo='campos.valor_uni.searchMinimo'
          :cpntMask='campos.valor_uni.mask'

          :cpntOnChange='campos.valor_uni.onChange'
          :cpntOnBlur='campos.valor_uni.onBlur'
          :cpntOnRealizaBusca='campos.valor_uni.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.valor_uni.onKeyPressEnter'
          ref="valor_uni"
          ></App-Input>
        </div>

        <div class="botoes">
          <span v-if="cpntPDocNFEmitida === false" v-shortkey="[ 'f3' ]" @shortkey="demComandaRapidaEmitirNF" data-tecla="F3">
            <App-Button cpntClass="btn btn-primary" @onClick="demComandaRapidaEmitirNF" :cpntStatus="statusBTs">
              <!-- SETA O ICONE A SER UTILIZADO -->
              <App-Icone :cpntTipo="'emitir'"></App-Icone>
  
              <!-- SETA A QUEBRA DE LINHA -->
              <br/>
  
              <!-- SETA O TEXTO DO BOTÃO -->
              <span>Emitir {{ cpntPDocTp }} [F3]</span>
            </App-Button>
          </span>

          <span v-else-if="cpntPDocNFEmitida === true" v-shortkey="[ 'f4' ]" @shortkey="demComandaRapidaDanfeNF(cpntPDocFiscal.id)" data-tecla="F4">
            <App-Button cpntClass="btn btn-primary" @onClick="demComandaRapidaDanfeNF(cpntPDocFiscal.id)" :cpntStatus="statusBTs">
              <!-- SETA O ICONE A SER UTILIZADO -->
              <App-Icone :cpntTipo="'danfe-icon'"></App-Icone>

              <!-- SETA A QUEBRA DE LINHA -->
              <br/>

              <!-- SETA O TEXTO DO BOTÃO -->
              <span>DANFE {{ cpntPDocTp }}  [F4]</span>
            </App-Button>
          </span>
        </div>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .dem-edi-com-rap {
    margin-top: 15px;
  }
    .dem-edi-com-rap > .campos > .dem-edi-com-rap--item {
      width: calc(55% - 20px);
    }
    .dem-edi-com-rap > .campos > .dem-edi-com-rap--qtde {
      width: calc(20%);
      margin-left: 10px;
    }
    .dem-edi-com-rap > .campos > .dem-edi-com-rap--valor_uni {
      width: calc(25%);
      margin-left: 10px;
    }

    .dem-edi-com-rap > .botoes {
      text-align: center;
      margin-top: 20px;
    }
      .dem-edi-com-rap > .botoes > button {
        padding: 10px 20px;
      }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      cpntPDocTp: {
        required: true
      },
      cpntDemandaTotal: {
        required: true
      },
      cpntPDocNFEmitida: {
        required: true
      },
      cpntPDocFiscal: {
        required: true
      },
      
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        atualizar: false,
        statusBTs: '',
        campos: {
          item: {
            id: 'dem-edi-com-rap--item',
            status: '',
            tabIndex: 17020001,
            nome: 'Produto (DIGITE e SELECIONE)',
            router: '/produto/get',
            method: 'POST',
            field: { id: null, codigo: null, cod_barra: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } }, id_pco_status: { j: { nome: null } }, valor_for_novo: { a: 'valor_for' }, valor_ven_novo: { a: 'valor_ven' } },
            fieldVirtual: [],
            where: 'dem-edi-pro',
            keyValue: 'id',
            keyMostra: [ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo produto' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.demComandaRapidaOnNovoProduto
            },
            apiEnv: 'id_pro',
            value: '',
            valueRef: '',
            mostrar: true,
            disabled: true,
            onRealizaBusca: this.demComandaRapidaOnRealizarBusca,
            onChange: this.demComandaRapidaOnChangeValue,
            onKeyPressEnter: this.demComandaRapidaOnKeyPressEnter
          },
          qtde: {
            id: 'dem-edi-com-rap--qtde',
            status: '',
            tabIndex: 17020002,
            nome: 'Quantidade',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'qtde',
            value: '1,00',
            mostrar: true,
            disabled: true,
            onChange: this.demComandaRapidaOnChangeValue,
            onKeyPressEnter: this.demComandaRapidaOnKeyPressEnter
          },
          valor_uni: {
            id: 'dem-edi-com-rap--valor_uni',
            status: '',
            nome: 'Valor Unitário (R$)',
            mask: 'valorDecimalNovo',
            apiEnv: 'valor_uni',
            value: '',
            mostrar: true,
            onChange: this.demComandaRapidaOnChangeValue,
            onKeyPressEnter: this.demComandaRapidaOnKeyPressEnter
          }
        }
      }
    },
    mounted: function () {
      this.demComandaRapidaIniciar()
    },
    methods: {
      demComandaRapidaIniciar: function () {
        // SETA O STATUS DA TELA
        this.demComandaRapidaSetarStatusGeral('carregando')

        // CARREGA OS DADOS DO PRODUTO SOLICITADO
        this.demComandaRapidaBuscarProduto().then(() => {
          // SETA O FOCUS NO CAMPO SOLICITADO
          this.demComandaRapidaOnRealizarFocusCampo('valor_uni')

          // SETA O STATUS DA TELA
          this.demComandaRapidaSetarStatusGeral('')
        })
      },
      demComandaRapidaSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demComandaRapidaFechar: function () {
        this.cpntFecharFormulario(this.atualizar)
      },
      demComandaRapidaOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.campos[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.campos[index].mensagem = ''
        this.campos[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demComandaRapidaOnKeyPressEnter: function (id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // VERIFICA O CAMPO QUE DEVE SER TRATADO
        switch (index) {
          case 'valor_uni':
            this.demComandaRapidaEmitirNF()
            break
        }
      },
      demComandaRapidaOnRealizarFocusCampo: function (chave, tentativa = 0) {
        if (this.$store.state.mobile === false) {
          if (tentativa <= 5) {
            if (this.campos[chave].mostrar === true && [ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
              this.$refs[chave].cpntRealizarFocus()
            } else {
              setTimeout(() => { this.demComandaRapidaOnRealizarFocusCampo(chave, (tentativa + 1)) }, 100)
            }
          }
        }
      },
      demComandaRapidaBuscarProduto: function () {
        return new Promise((success) => {
          // INICIA A VARIAVEL
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE BUSCAR
          queryGet.field = this.campos.item.field

          // SETA OS CAMPOS QUE DEVE BUSCAR
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id', o: '=', v: '1' } ] }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI(this.campos.item.router, this.campos.item.method, queryGet, (retorno) => {
            if (retorno.data.length === 0) {
              // SETA A MENSAGEM DE ERRO
              this.$store.state.msgWarn('WEB [406]: Produto com o ID 1 não encontrado para realizar o processo.', 'danger')

              // MANDA FECHAR A DIALOG
              this.demComandaRapidaFechar()
            } else {
              // SETA OS DADOS DO PRODUTO SOLICITADO
              this.demComandaRapidaOnChangeValue(retorno.data[0], this.campos.item.id)

              // FINALIZA O PROCESSO DE ATUALIZAÇÃO
              success()
            }
          }, this.demComandaRapidaSetarStatusGeral)
        })
      },
      demComandaRapidaEmitirNF: function () {
        // SETA O STATUS DOS BOTOES
        this.statusBTs = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA AS FUNÇÕES PARA REALIZAR O PROCESSO
        this.demComandaRapidaInserirProduto().then(() => {
          this.demComandaRapidaInserirPagamento().then(() => {
            this.demComandaRapidaEmitirNota().then(() => {
              // SETA O STATUS DOS BOTOES
              this.statusBTs = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          })
        })
      },
      demComandaRapidaInserirProduto: function () {
        return new Promise((success) => {
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API
  
          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_MONTAR_FORMDATA_API(this.campos, this).then((formData) => {
            // INICIAR VARIAVEL
            var campo = ''

            // VERIFICA VALIDAÇÃO
            if ([ '', null, undefined, '0', '0,', '0,0', '0,00', '0.', '0.0' , '0.00' ].indexOf(formData.valor_uni) !== -1) {
              // SETA A MENSAGEM DO CAMPO
              this.campos.valor_uni.mensagem = 'É necessario informar um valor valido para salvar'

              // SETA A VARIAVEL DE ERRO
              campo = 'valor_uni'
            }

            // VERIFICA SE TEM ALGUM ERRO NO FORMULARIO
            if (campo !== '') {  
              // SETA O FOCUS NO CAMPO SOLICITADO
              this.demComandaRapidaOnRealizarFocusCampo(campo)

              // SETA O STATUS DOS BOTOES
              this.statusBTs = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            } else {
              // INICIA A VARIAVEL
              var router = ''

              // SETA A ROTA QUE DEVE CHAMAR
              switch (this.cpntDemanda) {
                case 'venda':
                  // SETA A ROTA QUE DEVE CHAMAR
                  router = '/venda/produto'

                  // SETA O ID DA DEMANDA QUE DEVE SALVAR
                  formData.cod_venda = this.cpntDemandaId
                  break

                case 'compra':
                  // SETA A ROTA QUE DEVE CHAMAR
                  router = '/demanda/dem-compra/dem-produto'

                  // SETA O ID DA DEMANDA QUE DEVE SALVAR
                  formData.dem_compra = this.cpntDemandaId
                  break
              }

              // CONVERTE O VALOR RECEBIDO
              formData.valor_uni_novo = formData.valor_uni

              // REMOVE A CHAVE NÃO UTILIZADA
              delete formData.valor_uni

              // CONVERTE O VALOR EM LOT
              formData = { lot: [ formData ] }

              // CHAMA FUNÇÃO PARA COMUNICAR COM API
              this.$store.state.comunicaAPI(router, 'POST', formData, (retorno) => {
                // PEGA O RETORNO RECEBIDO
                retorno = retorno.lot[0]

                // VERIFICA SE O PROCESSO DEU CERTO
                if (retorno.code === '200') {
                  this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { success() })                  
                } else {
                  this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, this.campos, true, () => {
                    // SETA O STATUS DOS BOTOES
                    this.statusBTs = ''

                    // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                    this.time = new Date().getTime()
                  })
                }
              }, this.demComandaRapidaSetarStatusGeral)
            }
          }).catch(this.demComandaRapidaSetarStatusGeral)
        })
      },
      demComandaRapidaInserirPagamento: function () {
        return new Promise((success) => {
          // INICIA O VETOR
          var formData = { id_pgto: '1', valor: this.cpntDemandaTotal.produto.liquido }

          // VERIFICA SE TEM QUE ARRUMAR O VALOR DO CAMPO
          if ([ '', null, undefined ].indexOf(formData.valor) === -1) {
            // REMOVE O PONTO
            while (formData.valor.indexOf('.') !== -1) {
              formData.valor = formData.valor.replace('.', '')
            }

            // REMOVE A VIRGULA
            while (formData.valor.indexOf(',') !== -1) {
              formData.valor = formData.valor.replace(',', '')
            }
          }

          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda + '_pgto_df')

          // SETA A DEMANDA 
          formData[chaveD] = this.cpntDemandaId

          // CONVERTE O FORMULARIO PARA LOT
          formData = { lot: [ formData ] }

          // SETA O NOME DA ROTA
          var route = ''

          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'compra':
              route = '/demanda/dem-compra/dem-produto/df/pagamento'
              break

            case 'venda':
              route = '/venda/produto/df/pagamento'
              break
          }

          // COMUNICA COM A API
          this.$store.state.comunicaAPI(route, 'POST', formData, (retorno) => {
            // PEGA O RETORNO RECEBIDO
            retorno = retorno.lot[0]

            // VERIFICA SE O PROCESSO DEU CERTO
            if (retorno.code === '200') {
              this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { success() })                  
            } else {
              this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, this.campos, true, () => {
                // SETA O STATUS DOS BOTOES
                this.statusBTs = ''

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              })
            }
          }, this.demComandaRapidaSetarStatusGeral)
        })
      },
      demComandaRapidaEmitirNota: function () {
        return new Promise((success) => {
          // SETA O METHOD QUE DEVE CHAMAR
          var formData = {}

          // VERIFICA A DEMANDA QUE ESTÁ SENDO ENVIADA
          switch (this.cpntDemanda) {
            case 'venda':
              formData = { j_ref: JSON.stringify([ { tp: 'p', m: '10', id: this.cpntDemandaId } ]) }
              break
          
            case 'dev_cliente':
              formData = { j_ref: JSON.stringify([ { tp: 'p', m: '59', id: this.cpntDemandaId } ]) }
              break

            case 'dev_fornecedor':
              formData = { j_ref: JSON.stringify([ { tp: 'p', m: '60', id: this.cpntDemandaId } ]) }
              break

            case 'compra':
              formData = { j_ref: JSON.stringify([ { tp: 'p', m: '11', id: this.cpntDemandaId } ]) }
              break
          }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/df/emitir', 'POST', formData, (retorno) => {
            // PEGA O RETORNO RECEBIDO
            retorno = retorno.lot[0]

            // VERIFICA SE O PROCESSO DEU CERTO
            if (retorno.code === '200') {
              this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { success() })                  
            } else {
              this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, this.campos, true, () => {
                // SETA O STATUS DOS BOTOES
                this.statusBTs = ''

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              })
            }
          }, this.demComandaRapidaSetarStatusGeral)
        })
      },
      demComandaRapidaDanfeNF: function (id) {
        // SETA O STATUS DOS BOTOES
        this.statusBTs = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'ABRIR_DOC_FISCAL', id: id, acao: 'imprimir', origem: 'df' }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = () => {
          setTimeout(() => {
            // SETA O STATUS DOS BOTOES
            this.statusBTs = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, 1000)
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
    }
  }
</script>
